export enum ReminderSource {
  ClientProvided = 1,
  DoctorRecommended = 2,
}
